import axios from '../../../../helpers/axios';

// ----------------------------------------
// post userprofile handler
// ----------------------------------------
export const contactUsHandler = formData => {
  return axios.post('contact', { ...formData });
};
